module.exports = __webpack_public_path__ + "images/digital_nagriks.898549d8.webp";